/**
 * Chart Ring Modal Navigation
 * Modern vanilla JavaScript replacement for chart-ring functionality
 * Manages the step-by-step sizing questionnaire flow
 */

class ChartRingModal {
  constructor() {
    this.modal = null;
    this.currentQuestion = null;
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    this.modal = document.getElementById('size-chart');
    if (!this.modal) return;

    this.bindEvents();
    this.resetToFirstQuestion();
    this.setupSizeChartToggle();
  }

  bindEvents() {
    // Radio button navigation
    this.modal.addEventListener('change', (e) => {
      if (e.target.type === 'radio' && e.target.name.startsWith('question')) {
        this.handleQuestionChange(e.target);
      }
    });

    // Back button navigation
    this.modal.addEventListener('click', (e) => {
      if (e.target.classList.contains('back')) {
        this.handleBackButton(e.target);
      }
    });

    // Close modal events
    this.modal.addEventListener('click', (e) => {
      if (e.target.classList.contains('chartClose') || e.target.classList.contains('chartClose2')) {
        this.closeModal();
      }
    });

    // Reset when modal opens
    const openButton = document.querySelector('.btn-sizechart');
    if (openButton) {
      openButton.addEventListener('click', () => {
        setTimeout(() => this.resetToFirstQuestion(), 100);
      });
    }
  }

  handleQuestionChange(radioButton) {
    const targetId = radioButton.dataset.target;
    if (!targetId) return;

    // Hide current question
    const currentContainer = radioButton.closest('.question-container');
    if (currentContainer) {
      currentContainer.style.display = 'none';
    }

    // Show target question
    const targetContainer = document.getElementById(targetId);
    if (targetContainer) {
      targetContainer.style.display = 'block';
      this.currentQuestion = targetId;

      // Special handling for size chart display
      if (targetId === 'question1A') {
        this.modal.querySelector('.modal-content')?.classList.add('big');
      } else {
        this.modal.querySelector('.modal-content')?.classList.remove('big');
      }
    }
  }

  handleBackButton(backButton) {
    const buttonId = backButton.id;

    // Reset all radio buttons
    this.clearRadioSelections();

    // Determine which question to show based on back button ID
    const questionMap = {
      back1: 'q1',
      'back2-1': 'q1',
      'back-sizechart': 'q1',
    };

    const targetQuestionId = questionMap[buttonId] || 'q1';
    this.showQuestion(targetQuestionId);

    // Special modal size handling
    if (buttonId === 'back1') {
      this.modal.querySelector('.modal-content')?.classList.remove('big');
    }
  }

  showQuestion(questionId) {
    // Hide all questions
    const allQuestions = this.modal.querySelectorAll('.question-container');
    allQuestions.forEach((q) => (q.style.display = 'none'));

    // Show target question
    const targetQuestion = document.getElementById(questionId);
    if (targetQuestion) {
      targetQuestion.style.display = 'block';
      this.currentQuestion = questionId;
    }
  }

  clearRadioSelections() {
    const radioButtons = this.modal.querySelectorAll('input[type="radio"]');
    radioButtons.forEach((radio) => (radio.checked = false));
  }

  resetToFirstQuestion() {
    this.clearRadioSelections();
    this.showQuestion('q1');
    this.modal.querySelector('.modal-content')?.classList.remove('big');
  }

  closeModal() {
    // Modal closing is handled by the Dawn theme's modal system
    // Just reset the state for next time
    this.resetToFirstQuestion();

    // Remove scroll lock if it exists
    document.body.classList.remove('no-scroll');
  }

  setupSizeChartToggle() {
    // Handle size chart table toggle functionality
    const toggleElements = document.querySelectorAll('.size-chart-section h3[data-toggle="table"]');

    toggleElements.forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();

        const sizeChartSection = toggle.closest('.size-chart-section');
        if (!sizeChartSection) return;

        const table = sizeChartSection.querySelector('table');
        if (!table) return;

        // Toggle table visibility
        table.classList.toggle('hide-table');

        // Toggle chevron rotation
        toggle.classList.toggle('active');
      });
    });
  }
}

// Initialize when the script loads
new ChartRingModal();
